import React from 'react';

const FlashcardSetSelector = ({ onSetSelect, selectedSet, theme }) => {
  const sets = [
    { id: 1, name: 'Security+ Set 1', file: 'flashcards_1.json' },
    { id: 2, name: 'Security+ Set 2', file: 'flashcards_2.json' },
    { id: 3, name: 'Security+ Set 3', file: 'flashcards_3.json' }
  ];

  return (
    <div style={{ 
      marginBottom: '30px',
      padding: '30px',
      backgroundColor: theme.cardBackground,
      borderRadius: '16px',
      boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
      border: `2px solid ${theme.secondary}`,
      transition: 'all 0.3s ease'
    }}>
      <h2 style={{ 
        textAlign: 'center',
        marginBottom: '30px',
        color: theme.primary,
        fontSize: '2rem',
        fontWeight: '700'
      }}>Select a Flashcard Set</h2>
      <div style={{ 
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        maxWidth: '500px',
        margin: '0 auto'
      }}>
        {sets.map(set => (
          <button
            key={set.id}
            onClick={() => onSetSelect(set)}
            style={{
              padding: '20px 25px',
              backgroundColor: selectedSet?.id === set.id ? theme.primary : theme.optionBackground,
              color: selectedSet?.id === set.id ? theme.textLight : theme.text,
              border: `2px solid ${selectedSet?.id === set.id ? theme.primary : theme.secondary}`,
              borderRadius: '12px',
              cursor: 'pointer',
              fontSize: '18px',
              fontWeight: '600',
              transition: 'all 0.2s ease',
              boxShadow: selectedSet?.id === set.id ? '0 4px 12px rgba(40, 52, 28, 0.3)' : '0 2px 6px rgba(0,0,0,0.05)'
            }}
            onMouseOver={(e) => {
              if (selectedSet?.id !== set.id) {
                e.target.style.backgroundColor = theme.accent;
                e.target.style.color = theme.textLight;
                e.target.style.transform = 'translateY(-2px)';
              }
            }}
            onMouseOut={(e) => {
              if (selectedSet?.id !== set.id) {
                e.target.style.backgroundColor = theme.optionBackground;
                e.target.style.color = theme.text;
                e.target.style.transform = 'translateY(0px)';
              }
            }}
          >
            {set.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FlashcardSetSelector;
